export const title = '¿Qué incluye?';
export const included = 'Sí';
export const accordingToAvailability = 'Según disponibilidad';
export const notIncluded = 'No';
export const notMentioned = '—';
export const includedTooltip = 'Se muestra en "Incluye"';
export const accordingToAvailabilityTooltip =
  'Se muestra en "Según disponibilidad": disponible, pero sujeto a condiciones';
export const notIncludedTooltip = 'Se muestra en "No incluye"';
export const notMentionedTooltip = 'No se menciona en el sitio';
export const legend =
  'Sí aparece en "Incluye", Según disponibilidad aparece en su propia lista, No aparece en "No incluye", — no se menciona.';
export const retired = 'Retirada';
export const retiredTooltip =
  'Retirada del catálogo. Se sigue mostrando en los productos que ya la tienen.';
export const missingIconLabel = 'Sin ícono';
export const missingIconTooltip =
  'El sitio público no tiene un ícono para esta característica.';
